import type { MapItemCard } from "../../@types/mapviewxs";
import type { ItemCardControls } from "../map/types";

export interface Input {
  model: MapItemCard;
  itemCardControls?: ItemCardControls;
  itemIndex?: number;
  itemsTotal?: number;
  "on-close"?: () => void;
  "on-previous-item"?: () => void;
  "on-next-item"?: () => void;
}

export default class extends Marko.Component<Input> {
  declare lastKeyPressTime: number | null;

  onCreate() {
    this.lastKeyPressTime = null;
  }

  onPreviousItem(event: { originalEvent: Event }) {
    event.originalEvent.stopPropagation();
    this.emit("previous-item");
  }

  onNextItem(event: { originalEvent: Event }) {
    event.originalEvent.stopPropagation();
    this.emit("next-item");
  }

  onCloseHandler(event: { originalEvent: Event }) {
    event.originalEvent.stopPropagation();
    this.emit("close");
  }

  onKeyDownHandler(event: KeyboardEvent) {
    const now = Date.now();
    const throttleDelay = 100;

    if (this.lastKeyPressTime && now - this.lastKeyPressTime < throttleDelay) {
      return;
    }

    switch (event.key) {
      case "Escape":
        this.lastKeyPressTime = now;
        this.emit("close");
        break;

      case "Enter":
        this.lastKeyPressTime = now;
        this.handleEnterKey();
        event.preventDefault();
        event.stopPropagation();
        break;

      case "ArrowLeft":
        this.handleNavigation("previous-item", this.input?.itemIndex !== 0);
        break;

      case "ArrowRight":
        this.handleNavigation("next-item", this.input?.itemIndex !== (this.input?.itemsTotal ?? 0) - 1);
        break;
    }
  }

  handleEnterKey(): void {
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement && (activeElement.tagName === "BUTTON" || activeElement.hasAttribute("role"))) {
      activeElement.click();
      return;
    }

    const titleElement = document.querySelector(".preview-item-title");
    if (titleElement instanceof HTMLElement) {
      titleElement.click();
    }
  }

  handleNavigation(event: "previous-item" | "next-item", canNavigate: boolean): void {
    this.lastKeyPressTime = Date.now();
    if ((this.input?.itemsTotal ?? 0) >= 2 && canNavigate) {
      this.emit(event);
    }
  }
}
